import { render } from "./email.vue?vue&type=template&id=907cd1fc&scoped=true"
import script from "./email.vue?vue&type=script&lang=js"
export * from "./email.vue?vue&type=script&lang=js"

import "./email.vue?vue&type=style&index=0&id=907cd1fc&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-907cd1fc"

export default script